<div class="sectionb">

            <nav
                class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
                <span class="navbar-brand mb-0 h1"><i class="fas fa-dice-d6"></i> Flight: {{flight?.name}}</span> <span class="badge badge-primary">{{dataSource.filteredData.length}} files</span>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <div class="ml-auto d-flex justify-content-end">
                        <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item">
                                <a class="nav-link" role="button" (click)="refresh();false">
                                    <i class="fas fa-sync"></i>
                                </a>
                            </li>
                            <li class="nav-item dropdown" dropdown placement="bottom right">
                                <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                                  aria-expanded="false" dropdownToggle (click)="false">
                                  <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown1">
                                    <a class="dropdown-item text-danger" [routerLink]="" 
                                    *ngIf="uiShowButton(controlEnum.BTN_FLIGHT_OPERATOR,flight)"
                                    (click)="openDialogDeleteFlightFiles(flight)">
                                    <i class="far fa-trash-alt"></i> Delete all files
                                </a>
                                </div>  
                              </li>
                        </ul>
                    </div>
                </div>
            </nav>
      
            <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
            <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
            <perfect-scrollbar class="table-perfect-scrollbar">
            <table mat-table #table [dataSource]="dataSource" matSort
                class="table table-hover table-striped frms-table table-align-middle">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-id mat-uuid"> Id </th>
                    <td mat-cell *matCellDef="let row" class="table-header-id mat-uuid">
                        {{row.id}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="imageshower">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>File </th>
                    <td mat-cell *matCellDef="let row">
                        <app-uifile [filedata]="row"></app-uifile>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.name}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="filetype">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.type}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="filesize">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Size </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.filesize | filesize}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="creation_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation Date </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.creation_date | date:'dd-MM-yyyy HH:mm:sss'}}
                    </td>
                </ng-container> 
                <ng-container matColumnDef="date_taken">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Photo time </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.time | date:'dd-MM-yyyy HH:mm:sss'}}
                    </td>
                </ng-container> 
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status </th>
                    <td mat-cell *matCellDef="let row">
                        {{ui_getstatus(row)}}
                    </td>
                </ng-container>               
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                        <div class="td-actions text-right">
                            <button type="button" class="btn btn-sm btn-outline-secondary" [matMenuTriggerFor]="menu">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <mat-menu #menu="matMenu" class="">
                                <div mat-menu-item *ngIf="uiisdeletable(row)">
                                    <a class="dropdown-item text-danger" [routerLink]=""
                                        (click)="openDialogDeleteFlightFiles(row)">
                                        <i class="far fa-trash-alt"></i> Delete
                                    </a>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" class="thead-dark"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
            </table>
            </perfect-scrollbar>
            <mat-paginator [pageSizeOptions]="[20,50,100]" showFirstLastButtons></mat-paginator>
</div>